export default __webpack_public_path__ + "static/media/Montserrat-MediumItalic.ecdfe4c0.woff2";